module.exports = __webpack_public_path__ + "static/media/23120327_1638424316232753_1781576732630305347_o.ee01c6ee.jpg";